// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9035a64c","282":"294c5708","294":"6bb2981f","316":"2e17345e","748":"72381ba5","870":"632a60d4"}[chunkId] + ".chunk.js";
};